<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Date Ranges</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom" data-vv-name="form.tranDateFrom"
                    :error-messages="errors.collect('form.tranDateFrom')" v-validate="'required'" />
                </v-flex>
                <v-flex xs12 sm6>
                  <cal-picker v-model="form.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo" data-vv-name="form.tranDateTo"
                    :error-messages="errors.collect('form.tranDateTo')" v-validate="'required'" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Filters</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch" v-validate="'required'"
                    data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="form.clmStat" :items="clmStatList" :label="labels.clmStat" item-text="label" item-value="value" :data-vv-as="labels.clmStat" v-validate="'required'"
                    data-vv-name="form.clmStat" />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType" v-validate="'required'"
                    data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('form.busCls')" :data-vv-as="labels.busCls" v-validate="'required'"
                    data-vv-name="form.busCls" append-icon="mdi-magnify" @click:append="showBusClsHelpList=true" @click="showBusClsHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.execIC" :label="labels.execIC" :error-messages="errors.collect('form.execIC')" :data-vv-as="labels.execIC" v-validate="'required'"
                    data-vv-name="form.execIC" append-icon="mdi-magnify" @click:append="showExecICHelpList=true" @click="showExecICHelpList=true" readonly/>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.acctType" :label="labels.acctType" :error-messages="errors.collect('form.acctType')" :data-vv-as="labels.acctType" v-validate="'required'"
                    data-vv-name="form.acctType" append-icon="mdi-magnify" @click:append="showAcctTypeHelpList=true" @click="showAcctTypeHelpList=true" readonly/>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Sort Order</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <sort-order-table :columns="columns" :headers="headers" :sortedListContainer="sortedListContainer" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-toolbar-title>Report Setting</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select v-model="form.reportType" :items="reportTypeList" :label="labels.reportType" item-text="label" item-value="value" />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox :label="labels.pbClmRIRcvy" v-model="form.pbClmRIRcvy" :error-messages="errors.collect('pbClmRIRcvy')"
                    data-vv-name="pbClmRIRcvy" :data-vv-as="labels.pbClmRIRcvy" />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox :label="labels.pbPrtParam" v-model="form.pbPrtParam" :error-messages="errors.collect('pbPrtParam')"
                    data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            {{labels.export}}
            <v-icon dark right >mdi-arrow-right-bold-box</v-icon>
          </v-btn>
          <!--v-btn-toggle mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{format.label}}</span>
              <v-icon :color="format.color">{{format.icon}}</v-icon>
            </v-btn>
          </v-btn-toggle-->
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="showAcctTypeHelpList" width="900px" persistent>
      <multi-acct-type-help-list :acctType="form.acctType" @close="doClose" @doAssign="doAssignAcctType($event)" />
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
    </v-dialog>
    <v-dialog v-model="showBusClsHelpList" width="900px" persistent>
      <multi-bus-cls-help-list :busCls="form.busCls" @close="doClose" @doAssign="doAssignBusCls($event)" />
    </v-dialog>
    <v-dialog v-model="showExecICHelpList" width="900px" persistent>
      <multi-exec-in-charge-help-list :execic="form.execIC" @close="doClose" @doAssign="doAssignExecIC($event)"/>
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
    </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiAcctTypeHelpList from '@/components/core/common/dialog/MultiAcctTypeHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import SortOrderTable from '@/components/reusable/SortOrderTable'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
export default {
  mixins: [
    MessageMixin
  ],
  components: {
    MultiAcctTypeHelpList,
    MultiBranchHelpList,
    MultiBusClsHelpList,
    MultiExecInChargeHelpList,
    MultiPolTypeHelpList,
    SortOrderTable
  },
  data() {
    return {
      menu: {},
      showAcctTypeHelpList: false,
      showBranchHelpList: false,
      showBusClsHelpList: false,
      showExecICHelpList: false,
      showPolTypeHelpList: false,
      submitting: false,
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        branch: 'All',
        clmStat: 'All',
        polType: 'All',
        busCls: 'All',
        execIC: 'All',
        acctType: 'All',
        sortOrder: 'L',
        reportType: 'D',
        pbClmRIRcvy: false,
        pbPrtParam: false,
        format: 'PDF'
      },
      labels: {
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'To',
        branch: 'Branch',
        clmStat: 'Claim Status',
        polType: 'Policy Type',
        busCls: 'Business Class',
        execIC: 'Executive-in-Charge',
        acctType: 'Account Type',
        sortOrder: 'Sort Order',
        reportType: 'Report Type',
        pbClmRIRcvy: 'Generate Claims RI Recovery .csv file',
        pbPrtParam: 'Print Run Time Parameters',
        export: 'Proceed'
      },
      clmStatList: [
        { label: 'All', value: 'All' },
        { label: 'Closed', value: 'C' },
        { label: 'Open', value: 'O' },
        { label: 'Open/Reopen', value: 'B' },
        { label: 'Reopen', value: 'R' }
      ],
      reportTypeList: [
        { label: 'Both', value: 'B' },
        { label: 'Detail', value: 'D' },
        { label: 'Summary', value: 'S' }
      ],
      columns: [
        { label: 'Agent', value: 'agent' },
        { label: 'Branch', value: 'branch' },
        { label: 'Bus Source', value: 'busSrc' },
        { label: 'Claim Year', value: 'clmYr' },
        { label: 'Class', value: 'busCls' },
        { label: 'Class Group', value: 'busClsGrp' },
        { label: 'Client Type', value: 'clientType' },
        { label: 'Country', value: 'cty' },
        { label: 'Department', value: 'dept' },
        { label: 'Direct/RI', value: 'dri' },
        { label: 'Exec-in-Charge', value: 'execIC' },
        { label: 'Fund', value: 'fund' },
        { label: 'Loss Year', value: 'lossYr' },
        { label: 'Noticed Year', value: 'notYr' },
        { label: 'Policy Type', value: 'polType' },
        { label: 'Tran Type', value: 'tranType' },
        { label: 'UW Year', value: 'uwYr' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      sortedListContainer: {
        sortedList: [],
        cDescList: []
      },
      supportedFormat: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.riOutClmSum
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      if (this.sortedListContainer.sortedList.length === 0) {
        this.$toast.error('Please select sort columns.')
        return
      }
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          this.form.sort = this.sortedListContainer.sortedList
          this.form.cDesc = this.sortedListContainer.cDescList
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showBranchHelpList = false
      this.showBusClsHelpList = false
      this.showFundHelpList = false
      this.showPolTypeHelpList = false
      this.showAcctTypeHelpList = false
      this.showExecICHelpList = false
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignBusCls(obj) {
      this.form.busCls = []
      this.form.busCls = obj.finalSelectedItems.toString()
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    },
    async doAssignAcctType(Obj) {
      this.form.acctType = []
      this.form.acctType = Obj.finalSelectedItems.toString()
    },
    async doAssignExecIC(Obj) {
      this.form.execIC = Obj.finalSelectedItems.toString()
    }
  }
}
</script>
